/**
 * Created by chenjia on 2016/9/9.
 */
define(function(require,exports,module) {
    var slide = require('./unit/slide/slideV2');
    var nav = require('./unit/nav/navV2');
    var placeholder = require('./unit/placeholder/placeholder');
    var search = require('./unit/search/search');
    var gotop = require('./unit/gotop/gotopV2');
    var priceV2 = require('./unit/price/priceV2');
    var setUserInfo = require('./unit/setUserInfo/setUserInfo');
    var lazyload = require('./unit/lazyload/lazyload');
    // var shopcart = require('./unit/shopcart/shopcart');
    var comment = require('./unit/comment/comment');
    var indexV2Module = require('./module/indexV2Module');
    var nationalEntryModule = require('./module/nationalEntryModule');
    var floor = require('./module/floor');

    slide.slideBox({
        "data": slide.getImgData("tempHideInput"),
        "backgroundImg": false,
        "directBtn": true,
        "duration": 0.3, //滚动持续时间，单位：秒
        "direction": 'fadein',
        "delay": 5, //滚动延迟时间，单位：秒
        "hideClickBar": true, //不自动隐藏点选按键
        "clickBarRadius": 10,
        "width": 1210,
        "height": 369,
        "isLazyLoad": false,
        "id": "slideOne"
    });

    function addEvent(floorIdx) {
        var classes = $("[data-idx='"+floorIdx+"']").attr("class");
        if(classes.indexOf("temai") > -1) {
            // indexV2Module.addSaleFloorEvent();
        } else if(classes.indexOf("zhicai") > -1) {
            lazyload.fn.init();
            comment.fn.init("indexV2");
        } else {
            lazyload.fn.init();
            priceV2.init();
        }
    }

    floor.init(function(floorIdx) {
        addEvent(floorIdx);
    });


    nationalEntryModule.init();
    indexV2Module.init();
    setUserInfo();
    search.addSearchEvent();
    nav.handleNav();
    placeholder.init();
    lazyload.fn.init();
    gotop.goTop();
    // shopcart.init();
});


// WEBPACK FOOTER //
// ./src/js/indexV2.js